<script setup lang="ts">
import { useAuthStore } from '#modules/auth/store/auth';
import { storeToRefs } from 'pinia';
import { NavbarMenu } from '../components';
import { useMobileStore } from '../store/mobile';

const { user } = storeToRefs(useAuthStore());

const mobileStore = useMobileStore();
const { showMenu } = storeToRefs(mobileStore);
const { toggleMenu } = mobileStore;

const mobileIcon = computed((): string => {
  return showMenu.value ? 'mdi-close' : 'mdi-menu';
});
</script>

<template>
  <v-app-bar floating elevation="0" class="the-navbar">
    <v-app-bar-title>
      <nuxt-link to="/">
        <v-img src="/logo-horizontal.png" height="39px" class="nav-logo" />
      </nuxt-link>
    </v-app-bar-title>
    <!-- <v-menu width="200px">
      <template #activator="{ props }">
        <v-btn size="x-large" min-width="unset" rounded max-width="48" v-bind="props" class="the-navbar__profile">
          <AppAvatar size="small" :src="user?.avatar?.url || avatarPlaceholder" data-cy="avatar" />
        </v-btn>

        <AppButton
          variant="text"
          :icon="mobileIcon"
          color="black"
          class="the-navbar__mobile"
          @click="toggleMenu(null)"
        />
      </template>
      <NavbarMenu class="the-navbar__menu" />
    </v-menu> -->
  </v-app-bar>

  <div v-if="showMenu" class="the-navbar__mobile-menu">
    <NavbarMenu />
  </div>
</template>

<style lang="scss" scoped>
@use '~/assets/scss/_spacing.scss' as *;
@use '~/assets/scss/_variables.scss' as *;

:deep(.v-toolbar__content) {
  @include padding-x(64px);
  @include padding-y(24px);
  height: 87px !important;
  .v-toolbar-title {
    margin: 0;
  }
}

.the-navbar {
  border-bottom: 1px solid rgb(var(--v-theme-border-default));

  @media (max-width: $breakpoint-md) {
    :deep(.v-toolbar__content) {
      height: 56px !important;
      padding: $spacing-lg;
    }
  }

  .nav-logo {
    max-width: 153px;
  }

  &__profile {
  }

  &__mobile {
    display: none;
  }

  &__menu {
  }

  &__mobile-menu {
    display: none;
    position: fixed;
    // @NOTE: Header height
    top: 72px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .v-list {
      height: 100%;
    }
  }
}

@media (max-width: 768px) {
  .the-navbar {
    border-bottom: 1px solid whitesmoke;

    &__profile {
      display: none;
    }

    &__mobile {
      display: block;
    }

    &__mobile-menu {
      display: block;
    }
  }
}
</style>
